import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { SmoWorld } from '../../../../Models/Smo/SmoWorld';
import { smoWorldColors } from '../../../../Models/Smo/SmoWorldColors';
import { DEFAULT_GAME_LANGUAGE } from '../../../../Utils/Constants';
import { MoonIcon } from '../MoonIcon/MoonIcon';
import { MoonCellProps } from './MoonCellProps';

export const MoonCell: FunctionComponent<MoonCellProps> = ({
  className,
  moon,
  index,
  displayLanguage = DEFAULT_GAME_LANGUAGE,
  style = 'card'
}) => {
  const globalBoxStyle: string = 'px-4 py-3.5 v-stack space-y-2 rounded-lg';
  const cardBoxStyle: string = 'bg-bg-secondary box-border shadow-sm';
  const dashedBoxStyle: string = 'border-2 border-dashed';
  const dashedHighlightedBoxStyle: string = 'bg-tint bg-opacity-5 border-2 border-tint border-opacity-60 border-dashed';

  return (
    <div
      className={classNames(
        globalBoxStyle,
        style === 'card' ? cardBoxStyle : undefined,
        style === 'dashed' ? dashedBoxStyle : undefined,
        style === 'dashed-highlighted' ? dashedHighlightedBoxStyle : undefined,
        className
      )}
    >
      <div className="h-stack items-center justify-between">
        <div className="w-7 h-7">
          <MoonIcon />
        </div>
        {index ? (
          <div className="w-7 h-7 v-stack items-center justify-center text-tint text-sm font-medium bg-tint bg-opacity-10 rounded-full">
            <div>{index}</div>
          </div>
        ) : undefined}
      </div>
      <div className="v-stack items-start">
        <h4 className="font-medium tracking-wide">{moon.names[displayLanguage]}</h4>
        <h5
          className="px-2 v-stack space-y-0 text-sm rounded-full"
          style={{
            color: `${smoWorldColors[moon.location as SmoWorld]?.primary}`,
            background: `${smoWorldColors[moon.location as SmoWorld]?.primary}20`
          }}
        >
          {moon.location}
        </h5>
      </div>
    </div>
  );
};
